import { fetcher } from '@commenda/utils';
import { CustomerUpdateResponse, UpdateCustomerPayload } from './types';

export async function updateCustomer(
  customerId: string,
  body: UpdateCustomerPayload
): Promise<{
  success: boolean;
  data?: {
    data: CustomerUpdateResponse;
  };
  error?: string;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/customers/${customerId}`,
      {
        method: 'POST',
        body,
      },
      undefined
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to update customer',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}
